export enum CreateTeamFields {
  subdomain = 'subdomain',
}

export type CreateTeamSchema = {
  [CreateTeamFields.subdomain]: string;
}
